import InvoiceCard from '@Components/Cards/InvoiceCard'
import NoResults from '@Components/Templates/NoResults/NoResults'
import { useGetStandaloneInvoicesQuery } from '@Features/StandaloneCourse/Api/StandaloneCourseApi'
import { FlexLayout } from '@eduact/ed-system'
import { Theme } from '@eduact/student-theme'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SyncLoader } from 'react-spinners'
import styled from 'styled-components'
import { toInvoiceStatus, toInvoiceType } from '@Utilities/InvoiceEnums'

/** Standalone-course invoices (separate response shape from legacy invoices). */
const StandaloneInvoices: React.FC = () => {
	const [t] = useTranslation('courses')
	const [perPage, setPerPage] = useState(12)
	const { data, isFetching } = useGetStandaloneInvoicesQuery({ page: 1, perPage })

	const hasMoreData = useMemo(() => {
		if (!data) return false
		return data.data.length < (data.meta?.total ?? 0)
	}, [data])

	return (
		<FlexLayout padding="2rem 2.75rem" paddingTop="1rem" flexDirection={'column'}>
			<InvoicesGrid>
				{data?.data.map((invoice, index) => (
					<InvoiceCard
						key={`${invoice.id}-${index}-standalone`}
						amount={invoice.price?.toString() ?? invoice.total_price?.toString() ?? ''}
						date={invoice.created_at}
						invoiceReferenceNumber={invoice.invoice_ref}
						provider={'wallet'}
						providerReference={invoice.transaction_ref ?? ''}
						status={toInvoiceStatus(invoice.status)}
						type={toInvoiceType(invoice.type)}
					/>
				))}
			</InvoicesGrid>
			{data && data.data.length === 0 && !isFetching && <NoResults />}
			{isFetching && (
				<FlexLayout py="1rem" justifyContent={'center'}>
					<SyncLoader color={Theme.colors.primary} />
				</FlexLayout>
			)}
			{hasMoreData && !isFetching && (
				<FlexLayout py="1rem" justifyContent={'center'}>
					<LoadMoreButton onClick={() => setPerPage(current => current + 12)}>{t('view_all')}</LoadMoreButton>
				</FlexLayout>
			)}
		</FlexLayout>
	)
}

export default StandaloneInvoices

const InvoicesGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 2.875rem;
	row-gap: 2rem;
	border-radius: inherit;
	justify-content: center;
	${({ theme }) => `${theme.mediaQueries.large}{
		justify-content: initial;
	}`}
`
const LoadMoreButton = styled.button`
	border: none;
	cursor: pointer;
	border-radius: 999px;
	padding: 0.5rem 1.5rem;
	font-weight: bold;
	color: #fff;
	background: ${p => p.theme.colors.primary};
`
